import React from 'react';
import Text from './text';

export default function TextInputEmailWrapper(props) {
  return <Text {...props} pattern='^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$' validation='email' />;
}